import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { useVariables } from '../../../context/VariableContext';

const EnvironmentSelector = () => {
  const { environments, selectedEnvironmentId, setSelectedEnvironmentId, GLOBAL_OPTION, NONE_OPTION } = useVariables();

  return (
    <Box sx={{ minWidth: 180 }}>
      <FormControl fullWidth size="small">
        <Select
          value={selectedEnvironmentId || ""}
          onChange={(e) => setSelectedEnvironmentId(e.target.value || null)}
          displayEmpty
          sx={{
            backgroundColor: 'white',
            height: '36px',
            fontSize: '14px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d1d5db',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9ca3af',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
            '& .MuiSelect-select': {
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
            },
          }}
        >
          <MenuItem value={NONE_OPTION}>
            <Box component="span" sx={{ fontSize: '14px', fontWeight: 500 }}>
              None
            </Box>
          </MenuItem>
          <MenuItem value={GLOBAL_OPTION}>
            <Box component="span" sx={{ fontSize: '14px', fontWeight: 500 }}>
              Global
            </Box>
          </MenuItem>
          {environments.map((env) => (
            <MenuItem key={env.id} value={env.id}>
              <Box component="span" sx={{ fontSize: '14px', fontWeight: 500 }}>
                {env.environmentName}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EnvironmentSelector;
